const state = {
  vizElSelected: null,
  nextVizEl: null,
  prevVizEl: null,
  filterViz: 'versi',
  normalizeViz: null,
  mainVizTooltip: null,
  mainVizTooltipPos: null,
};

const mutations = {
  setVizElSelected (state, value) {
    state.vizElSelected = value;
      //reset normalize for scene when canto is selected
    if(state.vizElSelected && state.vizElSelected.depth === 3){
      state.normalizeViz = null;
    }
  },
  setNextVizEl (state, value) {
    state.nextVizEl = value;
  },
  setPrevVizEl (state, value) {
    state.prevVizEl = value;
  },
  setFilterViz (state, value) {
    state.filterViz = value;
  },
  setNormalizeViz (state, value) {
    state.normalizeViz = value;
  },
  setMainVizTooltip (state, value) {
    state.mainVizTooltip = value;
  },
  setMainVizTooltipPos (state, value) {
    state.mainVizTooltipPos = value;
  },
};

const getters = {
  getVizElSelected: state => state.vizElSelected,
  getNextVizElement: state => state.nextVizEl,
  getPrevVizElement: state => state.prevVizEl,
  getFilterViz: state => state.filterViz,
  getNormalizeViz: state => state.normalizeViz,
  getMainVizTooltip: state => state.mainVizTooltip,
  getMainVizTooltipPos: state => state.mainVizTooltipPos,
};

const actions = {
  setVizElSelected ({commit}, value) {
    commit ('setVizElSelected', value);
  },
  setNextVizEl ({commit}, value) {
    commit ('setNextVizEl', value);
  },
  setPrevVizEl ({commit}, value) {
    commit ('setPrevVizEl', value);
  },
  resetViz({commit}) {
    commit ('setVizElSelected', null);
  },
  setFilterViz ({commit}, value) {
    commit ('setFilterViz', value);
  },
  setNormalizeViz ({commit}, value) {
    commit ('setNormalizeViz', value);
  },
  setMainVizTooltip ({commit}, value) {
    commit ('setMainVizTooltip', value);
  },
  setMainVizTooltipPos ({commit}, value) {
    commit ('setMainVizTooltipPos', value);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
